<template>
  <div class="bigBox">
    <div class="left">
      <div class="title">重庆交运集团废旧物资拍卖系统</div>
      <div class="title1">请登录</div>
      <div class="line"></div>
      <div class="formBox">
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="auctionProjectCode">
            <el-input
              v-model="loginForm.auctionProjectCode"
              placeholder="请输入项目编号"
              style="width: 340px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="auctionAccount">
            <el-input
              v-model="loginForm.auctionAccount"
              placeholder="请输入平台用户名"
              style="width: 340px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="auctionPassword">
            <el-input
              v-model="loginForm.auctionPassword"
              placeholder="请输入密码"
              style="width: 340px"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="verification">
            <div class="elFormImg">
              <el-input
                v-model="loginForm.verification"
                placeholder="输入验证码"
                style="width: 200px"
                @keyup.enter.native="gohomepage"
              ></el-input>
              <img :src="baseImg" alt="" class="imgBlock" @click="getCodeapi" />
            </div>
            <div class="forget" @click="retrievePasswordGetCode">忘记密码?</div>
          </el-form-item>
          <el-form-item class="btnBox">
            <el-button class="" @click="gohomepage">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tips">
        温馨提示：若您参与的拍卖项目资料已通过审核，请根据短信通知的用户名及密码进行平台登录，若还未上传项目资料，请选择参拍项目并上传资料，如有疑问，请联系平台。
      </div>
    </div>

    <div class="right">
      <div class="right-notice">
        <div class="notice-title">
          <div style="display: flex">
            <div class="title-line"></div>
            <div class="title-name">拍卖场次</div>
          </div>
          <div class="more-img" @click="moreClick()">
            更多<img
              src="@/image/more.png"
              style="width: 10px; height: 10px; padding-left: 5px"
            />
          </div>
        </div>
        <div class="listQuery">
          <el-form :inline="true" :model="listQuery" class="demo-form-inline">
            <el-form-item label="进行状态：">
              <el-select
                clearable
                @change="searchClick"
                v-model="listQuery.progressStatus"
                placeholder="请选择"
              >
                <el-option label="即将开始" :value="3"></el-option>
                <el-option label="进行中" :value="4"></el-option>
                <el-option label="已结束" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
              clearable
              @change="searchClick"
                v-model="listQuery.keyWord"
                placeholder="请输入关键字"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="list.length > 0">
          <el-table :data="list" stripe border style="width: 100%" max-height="435px">
            <el-table-column
              prop="auctionProjectCode"
              label="项目编号"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="auctionStartTime"
              label="开始时间"
              width="170"
            >
            </el-table-column>
            <el-table-column prop="auctionEndTime" label="结束时间" width="170"> </el-table-column>
            <el-table-column prop="startingPrice" label="起拍价(元)">
              <template v-slot="scope">
                <span>{{scope.row.startingPrice?(scope.row.startingPrice/100).toFixed(2):'--'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="progressStatus" label="进行状态">
              <template v-slot="scope">
                <span v-if="scope.row.progressStatus==1" class="yellowColor">待审核</span>
                <span v-if="scope.row.progressStatus==2">待发布</span>
                <span v-if="scope.row.progressStatus==3">即将开始</span>
                <span v-if="scope.row.progressStatus==4" class="greenColor">进行中</span>
                <span v-if="scope.row.progressStatus==5 || scope.row.progressStatus==6" class="grayColor">已结束</span>
                <!-- 产品经理要求已流拍(6)的项目统一展示已结束 -->
                <!-- <span v-if="scope.row.progressStatus==6" class="redColor">流拍</span> -->
                <span v-if="scope.row.progressStatus==7" class="redColor">审核驳回</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer" v-if="total>8">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.current"
              background
              :page-size="listQuery.size"
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <noInfo v-else></noInfo>
      </div>
    </div>
    <!-- 验证码弹框 -->
    <bounced :dialogVisible.sync="dialogVisibleCode" title="获取手机验证码">
      <div slot="slotInfo" class="slotInfo">
        <div>
          <el-form :model="codeForm" ref="codeForm">
            <el-form-item
              prop="mobilePhone"
              :rules="{
                required: true,
                validator: (rule, value, callback) =>
                  regular.FormValidateIsTrue(
                    rule,
                    value,
                    callback,
                    regular.testPhone(value),
                    '请输入手机号'
                  ),
              }"
            >
              <el-input
                v-model="codeForm.mobilePhone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="verification"
              :rules="{
                required: true,
                validator: (rule, value, callback) =>
                  regular.FormValidateIsTrue(
                    rule,
                    value,
                    callback,
                    regular.verificationCode(value),
                    '请输入四位数验证码'
                  ),
              }"
            >
              <div class="elFormImg">
                <el-input
                  v-model="codeForm.verification"
                  placeholder="请输入验证码"
                  style="width: 300px"
                ></el-input>
                <img
                  class="imgBlock"
                  :src="codeImg"
                  alt=""
                  @click="retrievePasswordGetCode"
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button class="cancel" @click="cancelfn">取消</el-button>
          <el-button class="sureBtn" @click="submitcode">确定</el-button>
        </div>
      </div>
    </bounced>
    <!-- 短信验证码 -->
    <bounced :dialogVisible.sync="dialogVisiblesend" title="找回密码">
      <div slot="slotInfo" class="slotInfo">
        <el-form :model="formLabelAlign" ref="formLabelAlign">
          <el-form-item>
            <div>{{ codeForm.mobilePhone }},您正在找回密码！</div>
          </el-form-item>
          <el-form-item prop="auctionProjectCode">
            <el-input
              v-model="formLabelAlign.auctionProjectCode"
              placeholder="请输入项目编号"
            ></el-input>
          </el-form-item>
          <el-form-item class="phoneCode" prop="code">
            <el-input
              v-model="formLabelAlign.code"
              placeholder="输入手机验证码"
              style="width: 200px"
            ></el-input>
            <el-button
              @click="submitcode"
              :disabled="!isdisable"
              :class="isdisable ? 'btncode' : 'activeBtn'"
              >{{
                isdisable ? "获取验证码" : `${seconds}后重新获取`
              }}</el-button
            >
          </el-form-item>
        </el-form>
        <div class="btns">
          <el-button class="cancel" @click="cancelfn1">取消</el-button>
          <el-button class="sureBtn" @click="reSet">确定</el-button>
        </div>
      </div>
    </bounced>
  </div>
</template>

<script>
import { JSEncrypt } from "jsencrypt";
import noInfo from "@/components/noInfo.vue";
import regular from "@/util/regular";
import bounced from "@/components/bounced.vue";
import {
  getCode,
  auctionUserLogin,
  auctionProjectHomePage,
  retrievePasswordGetCode,
  verificationImageCode,
  verifySMSNewPassword,
} from "@/api/auction/index.js";
import { v4 as uuidv4 } from "uuid";
export default {
  components: {
    noInfo,
    bounced,
  },
  data() {
    return {
      total: 0,
      regular,
      list: [],
      formLabelAlign: {
        auctionProjectCode: "",
        code: "",
      },
      dialogVisibleCode: false,
      dialogVisiblesend: false,
      loginForm: {
        auctionProjectCode: "",
        auctionAccount: "",
        auctionPassword: "",
        uuid: "",
        verification: "",
      },
      codeForm: {
        mobilePhone: "",
        uuid: "",
        verification: "",
      },
      baseImg: "",
      listQuery: {
        current: 1,
        size: 8,
        progressStatus: null,
        keyWord: null,
        projectType: 1,
      },
      codeImg: "",
      seconds: 60,
      isdisable: false,
      rules: {
        auctionProjectCode: [
          {
            required: true,
            message: "请输入项目编号",
            trigger: "blur",
          },
        ],
        auctionAccount: [
          {
            required: true,
            message: "请输入平台用户名",
            trigger: "blur",
          },
        ],
        auctionPassword: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        verification: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCodeapi();
    this.auctionProjectHomePage();
  },
  methods: {
    retrievePasswordGetCode() {
      this.dialogVisibleCode = true;
      this.codeForm.uuid = uuidv4();
      let uuid = this.codeForm.uuid;
      retrievePasswordGetCode({ uuid: uuid }).then((res) => {
        if (res.data.code == 1) {
          this.codeImg = res.data.data;
        }
      });
    },
    moreClick() {
      // this.$router.go(-1);
      this.$router.push({name:'auction'})
    },
    cancelfn() {
      this.$refs.codeForm.resetFields();
      this.dialogVisibleCode = false;
    },
    submitcode() {
      this.$refs.codeForm.validate((volid) => {
        if (volid) {
          verificationImageCode(this.codeForm).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: res.data.data,
              });
              // this.$refs.codeForm.resetFields();
              this.dialogVisibleCode = false;
              this.dialogVisiblesend = true;
              this.isdisable = false;
              this.seconds = 60;
              this.countdownfn();
            }
          });
        }
      });
    },
    /* 倒计时 */
    countdownfn() {
      let id = setInterval((res) => {
        if (this.seconds >= 1) {
          this.seconds--;
        } else {
          this.isdisable = true;
          clearInterval(id);
        }
      }, 1000);
    },
    searchClick() {
      this.listQuery.current = 1
      this.auctionProjectHomePage()
    },
    auctionProjectHomePage() {
      auctionProjectHomePage(this.listQuery).then((res) => {
        if (res.data.code == 1) {
          let data = res.data.data || {};
          this.list = data.records || [];
          this.total = data.total || 0;
        }
      });
    },
    /* 获取验证码 */
    getCodeapi() {
      this.loginForm.uuid = uuidv4();
      let uuid = this.loginForm.uuid;
      getCode({
        uuid: uuid,
      }).then((res) => {
        if (res.data.code == 1) {
          this.baseImg = res.data.data;
        }
      });
    },
    handleCurrentChange(current) {
      this.listQuery.current = current;
      this.auctionProjectHomePage();
    },
    cancelfn1() {
      this.dialogVisiblesend = false;
    },
    reSet() {
      let data = {
        ...this.formLabelAlign,
        mobilePhone: this.codeForm.mobilePhone,
      };
      verifySMSNewPassword(data).then((res) => {
        if (res.data.code == 1) {
          this.$refs.codeForm.resetFields();
          this.$refs.formLabelAlign.resetFields();
          this.dialogVisiblesend = false;
          this.$message({
            type: "success",
            message: "重置密码成功，请注意查收短信",
          });
        }
      });
    },
    gohomepage() {
      this.$refs.loginForm.validate((v) => {
        if (v) {
          let data = {
            ...this.loginForm,
          };
          let publicKey =
            "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCjI6xANKnKoEvoKWxfTdWv+5GlK4fi9b/R4Tejb2Yh2ifASO3m6vu0NIMlYQbAdYu23u/qZ0n2aygQhMgWfXm2B+FH7meA1zVz2OygzCEKjw9K+HbEtfhqoDyiQVdHL9zTrRsZAzXhe98DwyR12qMhTQ1GDUsxTXXSgelh4uv/QQIDAQAB";
          let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
          encryptor.setPublicKey(publicKey); // 设置公钥
          data.auctionPassword = encryptor.encrypt(
            this.loginForm.auctionPassword
          );
          auctionUserLogin(data).then((res) => {
            if (res.data.code == 1) {
              // this.$router.go(-1);
              this.$router.push({
                path:'/home/auctionDetail',
                query: {
                  auctionProjectId: res.data.data.auctionProjectId
                }
              })
              sessionStorage.setItem(
                "auctionAccount",
                this.loginForm.auctionAccount
              );
              this.isaudit = false;
              sessionStorage.setItem(
                "auctionSessionId",
                res.data.data.sessionId
              );
              sessionStorage.setItem(
                "auctionProjectCode",
                res.data.data.auctionProjectCode
              );
              sessionStorage.setItem(
                "auctionProjectId",
                res.data.data.auctionProjectId
              );
              // auctionProjectId
            } else {
              this.getCodeapi()
            }
          }).catch(()=>{
            this.getCodeapi()
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.more-img {
  cursor: pointer;
}
.bigBox {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 90px;
  .elFormCode {
    .imgCode {
      display: block;
      width: 130px;
      height: 40px;
      margin: 0 auto 20px;
    }
  }
  .activeBtn {
    border: none !important;
    background-color: #e5e5e5 !important;
  }

  .btncode {
    background-color: #14d393 !important;
    border: 1px solid #14d393;
  }
  .phoneCode {
    /deep/.el-button {
      color: #fff !important;
      width: 130px;
      margin-left: 7px;
    }
  }
  .btns {
    text-align: center;
  }
  .sureBtn {
    width: 90px;
    height: 32px;
    background: #15d393;
    border: none;
    color: #fff;
    font-size: 12px;
  }

  .cancel {
    width: 90px;
    height: 37px;
  }
  .elFormImg {
    display: flex;
    .imgBlock {
      display: block;
      width: 130px;
      height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .left {
    width: 500px;
    height: 625px;
    border-radius: 10px;
    background: #f7f7f7;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    .tips {
      width: 340px;
      height: 72px;
      font-size: 14px;
      font-weight: 350;
      line-height: 24px;
      color: #3d3d3d;
      margin: 0 auto;
    }
    .forget {
      font-size: 12px;
      color: #15d393;
      cursor: pointer;
    }
    .formBox {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .btnBox {
      /deep/.el-button {
        background-color: #14d393 !important;
        color: #fff !important;
        width: 340px;
        border: 1px solid #14d393;
      }
    }

    .title {
      color: #15d393;
      font-size: 25px;
      font-weight: bold;
      margin-top: 33px;
      text-align: center;
    }
    .title1 {
      color: #3d3d3d;
      font-size: 28px;
      font-weight: bold;
      margin-top: 23px;
      text-align: center;
    }
    .line {
      width: 84px;
      height: 4px;
      background: #15d393;
      margin: 10px auto;
    }
  }
  .right {
    width: 692px;
    height: 618px;
    margin-left: 30px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
    padding: 20px 30px;
    .listQuery {
      margin-top: 30px;
    }
    .footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
    .right-notice {
      .notice-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        .title-line {
          display: inline-block;
          width: 6px;
          height: 20px;
          background: #15d393;
          border-radius: 0px 3px 3px 0px;
        }
        .title-name {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/auction/login.vue